export enum PremiseStatus {
    deenergized = 'D',
    active = 'A',
}
